import { logger } from '@/modules/common/logging/logger';
import { LayerNames, LayerVisibilityMode, StoredLayers } from '@/modules/common/types/layers';

import { ILayerService } from './ILayerService';

export class LayerServiceExceptionDecorator implements ILayerService {
  private decoree: ILayerService;

  constructor(decoree: ILayerService) {
    this.decoree = decoree;
  }

  setLayerVisibilityMode(layerName: LayerNames, mode: LayerVisibilityMode): void {
    try {
      this.decoree.setLayerVisibilityMode(layerName, mode);
    } catch (err) {
      this.logError('setLayerVisibilityMode', err);
    }
  }

  loadLayerVisibilityModes(visibilityModes: Partial<Record<LayerNames, LayerVisibilityMode>>): void {
    try {
      this.decoree.loadLayerVisibilityModes(visibilityModes);
    } catch (err) {
      this.logError('loadLayerVisibilityModes', err);
    }
  }

  showAllElements(): void {
    try {
      this.decoree.showAllElements();
    } catch (err) {
      this.logError('showAllElements', err);
    }
  }

  hideElements(idsToHide: string[]): void {
    try {
      this.decoree.hideElements(idsToHide);
    } catch (err) {
      this.logError('hideElements', err);
    }
  }

  showElements(idsToShow: string[]): void {
    try {
      this.decoree.showElements(idsToShow);
    } catch (err) {
      this.logError('showElements', err);
    }
  }

  setLayerLock(layerName: LayerNames, lock: boolean): void {
    try {
      this.decoree.setLayerLock(layerName, lock);
    } catch (err) {
      this.logError('setLayerLock', err);
    }
  }

  lockElements(idsToLock: string[]): void {
    try {
      this.decoree.lockElements(idsToLock);
    } catch (err) {
      this.logError('lockElements', err);
    }
  }

  unlockElements(idsToUnlock: string[]): void {
    try {
      this.decoree.unlockElements(idsToUnlock);
    } catch (err) {
      this.logError('unlockElements', err);
    }
  }

  loadLayersState(layers: StoredLayers): void {
    try {
      this.decoree.loadLayersState(layers);
    } catch (err) {
      this.logError('loadLayersState', err);
    }
  }

  private logError(methodName: string, err: unknown): void {
    logger.error(`Error in ${methodName}:`, err);
  }
}
